<template>
  <div>
    <validation-observer>
      <div
        v-for="(answerType, index) in input"
        :key="answerType.id"
        class="mt-4 row align-items-center justify-content-start"
      >
        <input class="custom-radio ms" :disabled="true" type="radio" />
        <div class="col-8 col-lg-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="answerType.name"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
            />
          </validation-provider>
        </div>

        <div v-if="index > 1" class="col-2 col-lg-3">
          <i
            class="far fa-times-circle text-danger"
            @click="triggerConfirmation(index)"
          />
        </div>
      </div>

      <div
        v-if="canAddMore"
        class="mt-4 row align-items-center justify-content-start"
      >
        <input class="custom-radio mr-3" :disabled="true" type="radio" />
        <div class="col-8 col-lg-3 ">
          <u class="add-button" @click="addAnswerType">
            Agregar una opción
          </u>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import alertMixin from 'utils/mixins/alert.mixin';
export default {
  name: 'VerticalInputs',
  components: {
    CustomInput,
  },
  mixins: [alertMixin],
  props: {
    input: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    canAddMore() {
      return this.input.length < 5;
    },
  },
  async mounted() {
    if (this.input.length === 0) {
      this.input.push({ id: 1, name: '' }, { id: 2, name: '' });
    }
  },
  methods: {
    addAnswerType() {
      const newId = this.input.length + 1;
      this.input.push({ id: newId, name: '' });
    },
    removeAnswerType(index) {
      if (this.input.length > 2) {
        this.input.splice(index, 1);
      }
    },
    async triggerConfirmation(index) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover la sección documentada? `,
        'Si',
        'No'
      );
      if (!answer) return;
      this.removeAnswerType(index);
    },
  },
};
</script>

<style scoped>
.add-button {
  color: #2cb484;
  cursor: pointer;
  font-size: 16px;
}
.custom-radio {
  transform: scale(2.1);
  margin-left: 2%;
}
</style>
